export const useStats = () => {
  // Mock data - in a real app this would come from GraphQL queries
  const getContentStats = () => {
    return [
      {
        title: "Events",
        count: "127",
        icon: "mdi-calendar-multiple",
        color: "primary",
        trend: "+12%",
      },
      {
        title: "Publications",
        count: "342",
        icon: "mdi-book-open-variant",
        color: "success",
        trend: "+8%",
      },
      {
        title: "People",
        count: "89",
        icon: "mdi-account-group",
        color: "info",
        trend: "+5%",
      },
      {
        title: "Projects",
        count: "56",
        icon: "mdi-folder-multiple",
        color: "warning",
        trend: "+15%",
      },
    ]
  }

  const getRecentActivity = () => {
    return [
      {
        title: "New event published",
        subtitle: "Advanced AI Workshop - 2 hours ago",
        icon: "mdi-calendar-plus",
        color: "primary",
      },
      {
        title: "Publication updated",
        subtitle: "Climate Research Paper #47 - 4 hours ago",
        icon: "mdi-book-edit",
        color: "success",
      },
      {
        title: "New fellow added",
        subtitle: "Dr. Sarah Johnson joined - 6 hours ago",
        icon: "mdi-account-plus",
        color: "info",
      },
      {
        title: "Project milestone reached",
        subtitle: "Digital Humanities Project - 1 day ago",
        icon: "mdi-flag-checkered",
        color: "warning",
      },
    ]
  }

  const getSystemStatus = () => {
    return [
      {
        service: "GraphQL API",
        status: "Online",
        icon: "mdi-check-circle",
        color: "success",
        uptime: "99.9%",
      },
      {
        service: "File Storage",
        status: "Online",
        icon: "mdi-check-circle",
        color: "success",
        uptime: "99.8%",
      },
      {
        service: "Search Engine",
        status: "Online",
        icon: "mdi-check-circle",
        color: "success",
        uptime: "99.7%",
      },
      {
        service: "Email Service",
        status: "Warning",
        icon: "mdi-alert-circle",
        color: "warning",
        uptime: "98.5%",
      },
    ]
  }

  return {
    getContentStats,
    getRecentActivity,
    getSystemStatus,
  }
}
